module.exports = __webpack_public_path__ + "img/img-01.6c4f2f17.jpg";